"use client";

import { styled } from "styled-components";

export const EmbeddedMain = styled.main`
  display: flex;
  flex-direction: column;
`;
